let token = null;

export const setCsrfToken = (t) => { token = t; };

export const getCsrfToken = () => token;

export const clearCsrfToken = () => { token = null; };
